import { Navigate } from "react-router-dom";
import { LoadingIndicator } from "@/components/application/loading-indicator/loading-indicator";
import { useClientAdmin } from "@/hooks/use-client-admin";

interface RequireClientAdminProps {
    children: React.ReactNode;
}

/**
 * Route guard that only renders children if the current user is a ClientAdmin.
 * Redirects to /home if not a ClientAdmin. Shows loading indicator while checking.
 */
export function RequireClientAdmin({ children }: RequireClientAdminProps) {
    const { isClientAdmin, isLoaded } = useClientAdmin();

    if (!isLoaded) {
        return (
            <div className="flex h-full w-full items-center justify-center">
                <LoadingIndicator size="lg" label="Loading..." />
            </div>
        );
    }

    if (!isClientAdmin) {
        return <Navigate to="/home" replace />;
    }

    return <>{children}</>;
}
